import { render, staticRenderFns } from "./view_list.vue?vue&type=template&id=06a46db0&scoped=true"
import script from "./view_list.vue?vue&type=script&lang=js"
export * from "./view_list.vue?vue&type=script&lang=js"
import style0 from "./view_list.vue?vue&type=style&index=0&id=06a46db0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a46db0",
  null
  
)

export default component.exports